import { Phone } from "lucide-react";

function FloatingCallButton() {
    return (
        <a
            href="tel:+919685851615"
            className="
        fixed
        bottom-6
        left-6
        z-[9999]
        w-16
        h-16
        bg-red-600
        rounded-full
        flex
        items-center
        justify-center
        shadow-2xl
        hover:bg-red-700
        transition
      "
            aria-label="Call OPD"
        >
            <Phone className="text-white w-7 h-7" />
        </a>
    );
}

export default FloatingCallButton;
